module.exports = __webpack_public_path__ + "static/media/details.5b41536c.svg";